import useProjectTeamService from '../useProjectTeamService';
import { mapTeamPlannedLeavesToBatchPayload } from './helpers';
import { PlannedLeaveFormRow } from './types';
import projectPlannedLeavesValidationSchema from '../projectPlannedLeavesValidationSchema';

export type PlannedLeavesFormData = {
  teamPlannedLeaves?: PlannedLeaveFormRow[];
};

const useProjectPlannedLeavesService = () => {
  const { teamPlannedLeavesBatch } = useProjectTeamService();

  const submitPlannedLeaves = async (projectId: string | number, plannedLeavesFormData: PlannedLeavesFormData) => {
    const teamPlannedLeaves = plannedLeavesFormData.teamPlannedLeaves || [];
    const batch = mapTeamPlannedLeavesToBatchPayload(String(projectId), teamPlannedLeaves);

    return {
      teamPlannedLeaves: await teamPlannedLeavesBatch(projectId, batch),
    };
  };

  const getPlannedLeavesValidationSchema = () => Promise.resolve(projectPlannedLeavesValidationSchema);

  return {
    getPlannedLeavesValidationSchema,
    submitPlannedLeaves,
  };
};

export default useProjectPlannedLeavesService;
